document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.blog-search-input');
  if (!inputs.length) return;

  inputs.forEach(input => {
    const container = input.closest('.blog-section') || document;
    const items = container.querySelectorAll('.blog-item');
    const noResults = container.querySelectorAll('.no-results-message');

    input.addEventListener('input', () => {
      const query = input.value.toLowerCase().trim();
      let visibleCount = 0;

      items.forEach(item => {
        const title = (item.dataset.title || item.textContent || '').toLowerCase();
        if (!query) {
          item.classList.add("hidden");
        } else if (title.includes(query)) {
          item.classList.remove("hidden");
          visibleCount++;
        } else {
          item.classList.add("hidden");
        }
      });

      noResults.forEach(msg => {
        msg.classList.toggle('hidden', !(query && visibleCount === 0));
      });
    });
  });

  const gridButtons = document.querySelectorAll(".grid-wrapper .blog_card");
  const blogArticles = document.querySelector(".cstm-blog-wrpper .blog-articles--1");
  const filterToggle = document.querySelector(".filter-toggle");
  const sideBar = document.querySelector(".cstm-sidebar");
  const blogWrapper = document.querySelector(".cstm-blog-wrpper");

  let selectedGrid = "grid--3-col";

  const updateGrid = () => {
    blogArticles.classList.remove("grid--1-col", "grid--2-col", "grid--3-col");
    if (sideBar.classList.contains("active")) {
      if (selectedGrid === "grid--1-col") {
        blogArticles.classList.add("grid--1-col");
      } else {
        blogArticles.classList.add("grid--2-col");
      }
    } else {
      blogArticles.classList.add(selectedGrid);
    }
  };

  if (gridButtons.length && blogArticles) {
    gridButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        gridButtons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
        selectedGrid = index === 0 ? "grid--3-col" : "grid--1-col";
        updateGrid();
      });
    });
  }

  if (filterToggle && sideBar && blogWrapper) {
    filterToggle.addEventListener("click", () => {
      sideBar.classList.toggle("active");
      blogWrapper.classList.toggle("active");
      updateGrid();
    });
  }

  const articlesOnPage = document.querySelector('.blog-articles--1');
  let nextUrl = articlesOnPage?.dataset.nextUrl;
  const loadMoreBtn = document.querySelector('.load-more_btn');
  const loadMoreSpinner = document.querySelector('.load-more_spinner');

  async function loadMoreProducts() {
    if (!nextUrl) return;
    loadMoreBtn.style.display = 'none';
    loadMoreSpinner.style.display = 'flex';

    try {
      const response = await fetch(nextUrl);
      const nextPageHTML = await response.text();
      loadMoreSpinner.style.display = 'none';
      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPageHTML, 'text/html');
      const newProducts = nextPageDoc.querySelector('.blog-articles--1');
      const newUrl = newProducts?.dataset.nextUrl;
      if (newUrl) {
        loadMoreBtn.style.display = 'flex';
      }
      nextUrl = newUrl;
      if (newProducts && articlesOnPage) {
        articlesOnPage.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      loadMoreSpinner.style.display = 'none';
      loadMoreBtn.style.display = 'flex';
    }
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', loadMoreProducts);
  }

  function sortArticles(order) {
    const articleContainers = document.querySelectorAll(".articles-wrapper");
    articleContainers.forEach(articleContainer => {
      const articles = Array.from(articleContainer.children);
      if (order === "newest" || order === "oldest") {
        articles.sort((a, b) => {
          const dateA = new Date(a.getAttribute("data-published-at"));
          const dateB = new Date(b.getAttribute("data-published-at"));
          return order === "newest" ? dateB - dateA : dateA - dateB;
        });
      } else if (order === "az" || order === "za") {
        articles.sort((a, b) => {
          const titleA = a.getAttribute("data-article").toLowerCase();
          const titleB = b.getAttribute("data-article").toLowerCase();
          return order === "az" ? titleA.localeCompare(titleB) : titleB.localeCompare(titleA);
        });
      }
      articles.forEach(article => articleContainer.appendChild(article));
    });
  }

  function initializeSorting() {
    const sortByDropdown = document.getElementById("sort-by");
    if(sortByDropdown){
    const initialSort = sortByDropdown.value;
    sortArticles(initialSort);
    sortByDropdown.addEventListener("change", function () {
      const sortOrder = this.value;
      sortArticles(sortOrder);
    });
  }
  }

  initializeSorting();

  document.addEventListener("DOMContentLoaded", () => {
  const viewAllBtn = document.getElementById("viewAllBtn");
  const loadMoreBtn = document.querySelector(".load-more");
  const monthItems = document.querySelectorAll("#monthYearList li");
  const articles = document.querySelectorAll(".article-item");
  let currentMonth = null;

  function showArticles(filterMonth = null) {
    let visibleArticles = [];

    articles.forEach(article => {
      const articleMonth = article.dataset.monthYear.toLowerCase().trim();
      if (!filterMonth || articleMonth === filterMonth) {
        visibleArticles.push(article);
        article.style.display = "flex";
      } else {
        article.style.display = "none";
      }
    });

    if (visibleArticles.length > 6) {
      loadMoreBtn.classList.remove("hidden");
      visibleArticles.forEach((a, i) => {
        if (i >= 6) a.classList.add("hidden");
        else a.classList.remove("hidden");
      });
    } else {
      loadMoreBtn.classList.add("hidden");
      visibleArticles.forEach(a => a.classList.remove("hidden"));
    }
  }

  monthItems.forEach(item => {
    item.addEventListener("click", () => {
      monthItems.forEach(m => m.classList.remove("active"));
      item.classList.add("active");
      currentMonth = item.dataset.monthYear.toLowerCase().trim();
      showArticles(currentMonth);
    });
  });

  loadMoreBtn.addEventListener("click", () => {
    const visibleArticles = Array.from(articles).filter(a =>
      currentMonth ? a.dataset.monthYear.toLowerCase().trim() === currentMonth : true
    );
    visibleArticles.forEach(a => a.classList.remove("hidden"));
    loadMoreBtn.classList.add("hidden");
  });

  viewAllBtn.addEventListener("click", () => {
    monthItems.forEach(m => m.classList.remove("active"));
    currentMonth = null;
    showArticles();
  });

  showArticles();
});


  // let mobileToggle = document.querySelector(".filter-toggle-mobile");
  // let mobileDrawer = document.querySelector(".mobile-drawer");
  // let closeDrawer = document.querySelector(".close-drawer");
  // mobileToggle.addEventListener("click", () => {
  //   if (mobileDrawer) {
  //     mobileDrawer.classList.add("active");
  //     document.body.classList.add("overflow-hidden");
  //   }
  // });
  // closeDrawer.addEventListener("click", () => {
  //   if (mobileDrawer) {
  //     mobileDrawer.classList.remove("active");
  //     document.body.classList.remove("overflow-hidden");
  //   }
  // });

  let mobileToggle = document.querySelector(".filter-toggle-mobile");
  let mobileSideBar = document.querySelector(".cstm-sidebar");
  if(mobileToggle && mobileSideBar){
  mobileToggle.addEventListener("click", function(){
    if(mobileToggle){
      mobileSideBar.classList.toggle("active");
         if (mobileSideBar.classList.contains("active")) {
      // sidebar ke position tak scroll kare
      mobileSideBar.scrollIntoView({
        behavior: "smooth", // smooth scroll
        block: "start" // sidebar ke top tak scroll kare
      });
    }
    
    }
  });
}
});



// document.addEventListener("DOMContentLoaded", function() {
//   const allArticles = document.querySelectorAll(".articles-wrapper .blog-articles__article");
//   const loadMoreBtn = document.querySelector(".load-more_btn");
//   const spinner = document.querySelector(".load-more_spinner");
//   let currentMonth = null;
//   const itemsPerPage = 6;
//   let visibleCount = itemsPerPage;

//   // Initially hide all after first 6
//   allArticles.forEach((a, i) => {
//     a.style.display = i < itemsPerPage ? "block" : "none";
//   });

//   // Load More logic
//   loadMoreBtn?.addEventListener("click", function() {
//     spinner.style.display = "block";
//     loadMoreBtn.style.display = "none";

//     setTimeout(() => {
//       let shown = 0;
//       allArticles.forEach((a, i) => {
//         // Agar month filter active hai to us month ke articles hi show karna
//         const matchMonth = !currentMonth || a.getAttribute("data-month-year") === currentMonth;
//         if (matchMonth && a.style.display === "none" && shown < itemsPerPage) {
//           a.style.display = "block";
//           shown++;
//         }
//       });

//       spinner.style.display = "none";

//       // Agar ab aur kuch hidden nahi bacha, button hide kar do
//       const hiddenLeft = Array.from(allArticles).some(
//         a => a.style.display === "none" && (!currentMonth || a.getAttribute("data-month-year") === currentMonth)
//       );
//       loadMoreBtn.style.display = hiddenLeft ? "flex" : "none";
//     }, 400);
//   });

//   // Month Filter logic (with toggle)
//   document.querySelectorAll("#monthYearList .month-year-item").forEach(btn => {
//     btn.addEventListener("click", function() {
//       const clickedMonth = this.getAttribute("data-month-year");

//       // Agar same month dubara click hua → reset to default view
//       if (currentMonth === clickedMonth) {
//         currentMonth = null;
//         document.querySelectorAll("#monthYearList .month-year-item").forEach(el => el.classList.remove("active"));

//         // Reset all articles to default view
//         allArticles.forEach((a, i) => {
//           a.style.display = i < itemsPerPage ? "block" : "none";
//         });

//         loadMoreBtn.style.display = allArticles.length > itemsPerPage ? "flex" : "none";
//         return; // Exit function yahan
//       }

//       // Normal filtering logic
//       currentMonth = clickedMonth;
//       console.log(currentMonth);
//       document.querySelectorAll("#monthYearList .month-year-item").forEach(el => el.classList.remove("active"));
//       this.classList.add("active");

//       // Hide all first
//       allArticles.forEach(a => {
//         if (a.getAttribute("data-month-year") === currentMonth) {
//           a.style.display = "block";
//         } else {
//           a.style.display = "none";
//         }
//       });

//       // Only show first 6 of filtered
//       const filtered = Array.from(allArticles).filter(a => a.getAttribute("data-month-year") === currentMonth);
//       filtered.forEach((a, i) => {
//         a.style.display = i < itemsPerPage ? "block" : "none";
//       });

//       // Reset visible count and show/hide load more
//       visibleCount = itemsPerPage;
//       loadMoreBtn.style.display = filtered.length > itemsPerPage ? "flex" : "none";
//     });
//   });

//   // 🔥 Auto trigger filter if coming from article page
//   const savedMonth = localStorage.getItem("selectedMonthYear");
//   if (savedMonth) {
//     const matchBtn = document.querySelector(`#monthYearList .month-year-item[data-month-year="${savedMonth}"]`);
//     if (matchBtn) {
//       matchBtn.click(); // Trigger the click to auto-filter
//     }
//     localStorage.removeItem("selectedMonthYear"); // Optional: clear after use
//   }
// });
